module.exports = __webpack_public_path__ + "img/sc-1-act.681e2b44.png";